<template>
  <div class="col-lg-12 pb-4">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title mb-4">
          <div class="row">
            <div class="col-sm-4 h3 font-weight-bold">
              {{ $t("overview.sna") }}
            </div>
            <div class="col-sm-8 text-right">
              <b-button
                @click="refresh()"
                class="btn btn-sm p-0 px-1 mx-2"
                variant="success"
                v-if="
                  id_user === id_analys ||
                  id_user === manager ||
                  user_type === 'superadmin' ||
                  user_type === 'admin' ||
                  user_type === 'vvip'
                "
                ><i
                  :class="loading ? 'mdi-spin' : ''"
                  class="mdi mdi-18px mdi-refresh p-0"
                ></i
              ></b-button>
            </div>
          </div>
        </h4>
        <div class="row">
          <div class="col-12">
            <div>
              <div class="border rounded h-100" style="min-height: 100vh">
                <div
                  class="d-flex m-2 justify-content-end position-absolute"
                  style="right: 0; z-index: 99"
                >
                  <div
                    class="d-flex align-items-center mr-3 btn btn-light"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Tingkatan (degree) yang menunjukkan popularitas aktor dalam jaringan sosial. Tingkatan (degree) adalah jumlah link (relasi diantara aktor) dari dan ke aktor (individu). Ukuran ini menunjukkan posisi individu dalam jaringan, dimana dalam jaringan yang directed (mempunyai arah) individu atau aktor yang populer akan sering dihubungi (indegree) maupun menghubungi (outdegree)"
                  >
                    <i class="bx bxs-circle bx-sm text-primary"></i>
                    <span class="ml-2">Degree</span>
                  </div>
                  <div
                    class="d-flex align-items-center mr-3 btn btn-light"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Menunjukkan posisi aktor (node) sebagai perantara (betweenness) dari hubungan aktor (individu) satu dengan aktor lain (individu). Aktor yang memiliki betweenness centrality paling tinggi adalah yang memiliki kemampuan penghubung yang baik antar aktor dalam sebuah jaringan, serta memegang kontrol manipulasi atas informasi"
                  >
                    <i class="bx bxs-circle bx-sm text-warning"></i>
                    <span class="ml-2">Betweeness</span>
                  </div>
                  <div
                    class="d-flex align-items-center mr-3 btn btn-light"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Sentralitas kedekatan  (keperentaraan) menggambarkan penghitungan jalur terpendek (shorted path lengths) dari satu aktor (node) ke aktor (node) yang lain. Pengukuran closeness centrality dari berapa banyak langkah (jalur/path) seorang aktor bisa menghubungi atau dihubungi oleh aktor lain dalam jaringan. Aktor (node) ini dapat menyebarluaskan informasi lebih cepat serta memiliki lebih sedikit perantara."
                  >
                    <i class="bx bxs-circle bx-sm text-success"></i>
                    <span class="ml-2">Closeness</span>
                  </div>
                </div>
                <div
                  class="panel-toggle position-absolute my-2 mx-3"
                  style="z-index: 99"
                >
                  <b-button-group vertical>
                    <b-tooltip
                      target="tooltip-right-button"
                      placement="right"
                    ></b-tooltip>
                    <b-button
                      id="button-zoom-in"
                      size="sm"
                      variant="secondary"
                      class="p-0 px-2 py-1"
                      @click="zoomIn"
                    >
                      <i class="mdi mdi-magnify-plus mdi-24px p-0"></i>
                    </b-button>
                    <b-tooltip target="button-zoom-in" placement="right">
                      Zoom In
                    </b-tooltip>
                    <b-button
                      id="button-zoom-out"
                      size="sm"
                      variant="secondary"
                      class="p-0 px-2 py-1"
                      @click="zoomOut"
                    >
                      <i class="mdi mdi-magnify-minus mdi-24px p-0"></i>
                    </b-button>
                    <b-tooltip target="button-zoom-out" placement="right">
                      Zoom Out
                    </b-tooltip>
                    <b-button
                      id="button-fit-canvas"
                      size="sm"
                      variant="secondary"
                      class="p-0 px-2 py-1"
                      @click="resetZoom"
                    >
                      <i class="mdi mdi-crosshairs-gps mdi-24px p-0"></i>
                    </b-button>
                    <b-tooltip target="button-fit-canvas" placement="right">
                      Fit Canvas
                    </b-tooltip>
                  </b-button-group>
                  <br />
                  <b-button-group vertical class="mt-2">
                    <b-tooltip
                      target="tooltip-right-button"
                      placement="right"
                    ></b-tooltip>
                    <b-button
                      id="button-ly1"
                      size="sm"
                      :variant="select_mode == 'cose' ? 'primary' : 'secondary'"
                      class="p-0 px-2 py-1"
                      @click="changeType('cose')"
                    >
                      <i class="mdi mdi-source-branch mdi-24px p-0"></i>
                    </b-button>
                    <b-tooltip target="button-ly1" placement="right">
                      Cose Layout
                    </b-tooltip>
                    <b-button
                      id="button-ly2"
                      size="sm"
                      :variant="select_mode == 'tree' ? 'primary' : 'secondary'"
                      class="p-0 px-2 py-1"
                      @click="changeType('tree')"
                    >
                      <i class="mdi mdi-sitemap mdi-24px p-0"></i>
                    </b-button>
                    <b-tooltip target="button-ly2" placement="right">
                      Tree Layout
                    </b-tooltip>
                    <b-button
                      id="button-ly3"
                      size="sm"
                      :variant="
                        select_mode == 'concentric' ? 'primary' : 'secondary'
                      "
                      class="p-0 px-2 py-1"
                      @click="changeType('concentric')"
                    >
                      <i class="mdi mdi-graphql mdi-24px p-0"></i>
                    </b-button>
                    <b-tooltip target="button-ly3" placement="right">
                      Concentric Layout
                    </b-tooltip>
                  </b-button-group>
                  <br />
                  <b-button-group vertical class="mt-2">
                    <b-tooltip
                      target="tooltip-right-button"
                      placement="right"
                    ></b-tooltip>
                    <b-button
                      id="button-download"
                      size="sm"
                      variant="secondary"
                      class="p-0 px-2 py-1"
                      @click="downloadAsImage()"
                    >
                      <i class="mdi mdi-camera-iris mdi-24px p-0"></i>
                    </b-button>
                    <b-tooltip target="button-download" placement="right">
                      Screenshot
                    </b-tooltip>
                  </b-button-group>
                </div>
                <cytoscape
                  style="height: 100%"
                  ref="cyRef"
                  :afterCreated="afterCreated"
                  :preConfig="preConfig"
                  :config="config"
                  v-on:mousedown="addNode"
                  v-on:cxttapstart="updateNode"
                >
                  <!-- <cy-element
                    v-for="(def, defidx) in config.elements"
                    :key="defidx"
                    :definition="def"
                    v-on:mousedown="deleteNode($event, defidx)"
                  /> -->
                </cytoscape>
              </div>
            </div>
            <!-- <div v-if="loadingnew" class="mt-4 mx-auto p-5">
              <div class="text-center">
                <div
                  class="spinner-border text-secondary"
                  role="status"
                  v-if="loadingnew"
                >
                  <span class="sr-only"
                    ><p>{{ $t("website.website-info") }}</p></span
                  >
                </div>
              </div>
            </div> -->
          </div>
          <div class="col-12 mt-5">
            <span class="h3 font-weight-bold">
              {{ $t("overview.table-of-centrality") }}
            </span>
            <hr />
            <div class="row">
              <div class="col-4">
                <div class="mb-4">
                  <p class="h5">Top 5 Degree</p>
                  <table class="table table-striped mb-0">
                    <thead>
                      <tr>
                        <th>Node</th>
                        <th>{{ $t("overview.score") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(value, key, index) in degrees"
                        :key="key"
                        :class="index == 0 ? 'bg-primary text-white' : ''"
                      >
                        <td v-if="index < 5">{{ key }}</td>
                        <td v-if="index < 5">
                          {{ JSON.stringify(value).substr(0, 9) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-4">
                <div class="mb-4">
                  <p class="h5">Top 5 Betweeness</p>
                  <table class="table table-striped mb-0">
                    <thead>
                      <tr>
                        <th>Node</th>
                        <th>{{ $t("overview.score") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(value, key, index) in betweeness"
                        :key="key"
                        :class="index == 0 ? 'bg-warning text-white' : ''"
                      >
                        <td v-if="index < 5">{{ key }}</td>
                        <td v-if="index < 5">
                          {{ JSON.stringify(value).substr(0, 9) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-4">
                <div class="mb-4">
                  <p class="h5">Top 5 Closeness</p>
                  <table class="table table-striped mb-0">
                    <thead>
                      <tr>
                        <th>Node</th>
                        <th>{{ $t("overview.score") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(value, key, index) in closeness"
                        :key="key"
                        :class="index == 0 ? 'bg-success text-white' : ''"
                      >
                        <td v-if="index < 5">{{ key }}</td>
                        <td v-if="index < 5">
                          {{ JSON.stringify(value).substr(0, 9) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- <simplebar style="max-height: 60vh">
            </simplebar> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TargetService from "@/helpers/target-profile.service";
import cola from "cytoscape-cola";
import coseBilkent from "cytoscape-cose-bilkent";
import avsdf from "cytoscape-avsdf";
import simplebar from "simplebar-vue";
import cytoscape from "cytoscape";
import noOverlap from "cytoscape-no-overlap";
import { saveAs } from "file-saver";

export default {
  components: { simplebar },
  props: [
    "nametarget",
    "imgtarget",
    "idtarget",
    "twitter",
    "id_analys",
    "manager",
    "id_user",
    "user_type",
    "in_report",
  ],

  data() {
    var baseUrl = window.location.origin;
    return {
      cy: null,
      cy_png: "",
      baseUrl: baseUrl + "/project-overview/",
      loadingnew: false,
      title: "Social Network Analysis",
      dataRelation: false,
      select_mode: "cose",
      config: {
        layout: {
          name: "cose-bilkent",
          animate: true,
          fit: true,
          nodeOverlap: 0,
          nodeSpacing: 45,
          idealEdgeLength: 500,
          gravity: 1,
          componentSpacing: 40,
          animationDuration: 2000,
        },
        style: [
          {
            selector: "node[id='" + this.idtarget + "']",
            style: {
              width: "70px",
              height: "70px",
              content: "data(label)",
              "text-transform": "uppercase",
              color: "#555555",
              "font-size": "16px",
              "font-weight": "bold",
              "text-valign": "bottom",
              "text-halign": "center",
              "text-outline-color": "#556ee6",
              "text-outline-width": "2px",
              color: "#fff",
              "overlay-padding": "6px",
              "z-index": "10",
              "background-image":
                process.env.VUE_APP_BASE_API_URL_IMAGE + this.imgtarget,
              "background-width": "70px",
              "background-height": "70px",
              "border-color": "#556ee6",
              "border-opacity": "1",
              "border-width": "5px",
            },
          },

          {
            selector: "edge",
            style: {
              "curve-style": "straight",
              // "curve-style": "haystack",
              // "haystack-radius": 0,
              width: 1,
              "line-color": "#2A3042",
              "target-arrow-shape": "triangle-backcurve",
              "target-arrow-color": "#2A3042",
            },
          },
        ],
        elements: {
          nodes: [
            {
              data: {
                id: this.idtarget,
                label: this.nametarget,
              },
            },
          ],
          edges: [],
        },
      },
      degrees: [],
      betweeness: [],
      closeness: [],
      items: [
        {
          text: "Utility",
          href: "/",
        },
        {
          text: "Timeline",
          active: true,
        },
      ],
      loading: false,
      zoomLevel: 0,
    };
  },
  methods: {
    refresh() {
      this.$refs.cyRef.cy.then((cy) => {
        cy.layout(this.config.layout).stop();
        cy.layout(this.config.layout).run();
      });
      this.loading = true;
      this.dataRelation = false;
      this.getRelation();
    },
    getRelation() {
      let data = {
        id_target: this.idtarget,
      };
      TargetService.getRelatedTarget(data)
        .then((response) => {
          this.config.elements.edges = [];
          this.config.elements.nodes = [];
          this.config.elements.nodes = [
            {
              data: {
                id: this.idtarget,
                label: this.nametarget,
              },
            },
          ];
          this.config.style = [
            {
              selector: "node[id='" + this.idtarget + "']",
              style: {
                width: "150px",
                height: "150px",
                content: "data(label)",
                "text-transform": "uppercase",
                color: "#555555",
                "font-size": "16px",
                "font-weight": "bold",
                "text-valign": "bottom",
                "text-halign": "center",
                "text-outline-color": "#556ee6",
                "text-outline-width": "2px",
                color: "#fff",
                "overlay-padding": "6px",
                "z-index": "10",
                "background-image": [
                  process.env.VUE_APP_BASE_API_URL_IMAGE + this.imgtarget,
                ],
                "background-width": "150px",
                "background-height": "150px",
                "border-color": "#556ee6",
                "border-opacity": "1",
                "border-width": "5px",
              },
            },

            {
              selector: "edge",
              style: {
                "curve-style": "straight",
                width: 1,
                "line-color": "#2A3042",
                "target-arrow-shape": "triangle-backcurve",
                "target-arrow-color": "#2A3042",
              },
            },
          ];
          this.degrees = response.data.degree;
          this.betweeness = response.data.betweeness;
          this.closeness = response.data.closeness;

          // console.log("degereddd ", Object.keys(this.degrees).slice(0, 5)[0]);

          response.data.nodes.forEach((el) => {
            if (el.id != this.idtarget) {
              const data_nodes = {
                data: {
                  id: el.id,
                  label: el.name,
                  parent_node: this.idtarget,
                  id_target: el.id,
                },
              };
              this.config.elements.nodes.push(data_nodes);
              let style_node = {};
              if (
                Object.keys(this.degrees).slice(0, 5).includes(el.name) ||
                Object.keys(this.betweeness).slice(0, 5).includes(el.name) ||
                Object.keys(this.closeness).slice(0, 5).includes(el.name)
              ) {
                if (
                  Object.keys(this.degrees).slice(0, 5)[0] == el.name ||
                  Object.keys(this.betweeness).slice(0, 5)[0] == el.name ||
                  Object.keys(this.closeness).slice(0, 5)[0] == el.name
                ) {
                  style_node = {
                    selector: "node[id_target='" + el.id + "']",
                    style: {
                      width: "150px",
                      height: "150px",
                      content: "data(label)",
                      "background-image": [
                        process.env.VUE_APP_BASE_API_URL_IMAGE + el.image,
                      ],
                      "background-width": "150px",
                      "background-height": "150px",
                    },
                  };
                } else {
                  style_node = {
                    selector: "node[id_target='" + el.id + "']",
                    style: {
                      width: "100px",
                      height: "100px",
                      content: "data(label)",
                      "background-image": [
                        process.env.VUE_APP_BASE_API_URL_IMAGE + el.image,
                      ],
                      "background-width": "100px",
                      "background-height": "100px",
                    },
                  };
                }
              } else {
                style_node = {
                  selector: "node[id_target='" + el.id + "']",
                  style: {
                    width: "70px",
                    height: "70px",
                    content: "data(label)",
                    "background-image": [
                      process.env.VUE_APP_BASE_API_URL_IMAGE + el.image,
                    ],
                    "background-width": "70px",
                    "background-height": "70px",
                  },
                };
              }
              this.config.style.push(style_node);
            }
            if (Object.keys(this.degrees).slice(0, 5).includes(el.name)) {
              if (
                Object.keys(this.degrees).slice(0, 5)[0] == el.name ||
                Object.keys(this.betweeness).slice(0, 5)[0] == el.name ||
                Object.keys(this.closeness).slice(0, 5)[0] == el.name
              ) {
                let text_style_degree = {
                  selector: "node[id_target='" + el.id + "']",
                  style: {
                    "text-transform": "uppercase",
                    color: "#555555",
                    "font-size": "16px",
                    "text-valign": "bottom",
                    "text-halign": "center",
                    "text-outline-color": "#0067AC",
                    "text-outline-width": "2px",
                    color: "#fff",
                    "overlay-padding": "6px",
                    "z-index": "10",
                    "border-color": "#0067AC",
                    "border-opacity": "1",
                    "border-width": "5px",
                  },
                };
                this.config.style.push(text_style_degree);
              } else {
                let text_style_degree = {
                  selector: "node[id_target='" + el.id + "']",
                  style: {
                    "text-transform": "uppercase",
                    color: "#555555",
                    "font-size": "16px",
                    "text-valign": "bottom",
                    "text-halign": "center",
                    "text-outline-color": "#0067AC",
                    "text-outline-width": "2px",
                    color: "#fff",
                    "overlay-padding": "6px",
                    "z-index": "10",
                    "border-color": "#0067AC",
                    "border-opacity": "1",
                    "border-width": "5px",
                  },
                };
                this.config.style.push(text_style_degree);
              }
            }
            if (Object.keys(this.betweeness).slice(0, 5).includes(el.name)) {
              if (
                Object.keys(this.degrees).slice(0, 5)[0] == el.name ||
                Object.keys(this.betweeness).slice(0, 5)[0] == el.name ||
                Object.keys(this.closeness).slice(0, 5)[0] == el.name
              ) {
                let text_style_betweeness = {
                  selector: "node[id_target='" + el.id + "']",
                  style: {
                    "text-transform": "uppercase",
                    color: "#555555",
                    "font-size": "16px",
                    "text-valign": "bottom",
                    "text-halign": "center",
                    "text-outline-color": "#F1B44C",
                    "text-outline-width": "2px",
                    color: "#fff",
                    "overlay-padding": "6px",
                    "z-index": "10",
                    "border-color": "#F1B44C",
                    "border-opacity": "1",
                    "border-width": "5px",
                  },
                };
                this.config.style.push(text_style_betweeness);
              } else {
                let text_style_betweeness = {
                  selector: "node[id_target='" + el.id + "']",
                  style: {
                    "text-transform": "uppercase",
                    color: "#555555",
                    "font-size": "16px",
                    "text-valign": "bottom",
                    "text-halign": "center",
                    "text-outline-color": "#F1B44C",
                    "text-outline-width": "2px",
                    color: "#fff",
                    "overlay-padding": "6px",
                    "z-index": "10",
                    "border-color": "#F1B44C",
                    "border-opacity": "1",
                    "border-width": "5px",
                  },
                };
                this.config.style.push(text_style_betweeness);
              }
            }
            if (Object.keys(this.closeness).slice(0, 5).includes(el.name)) {
              if (
                Object.keys(this.degrees).slice(0, 5)[0] == el.name ||
                Object.keys(this.betweeness).slice(0, 5)[0] == el.name ||
                Object.keys(this.closeness).slice(0, 5)[0] == el.name
              ) {
                let text_style_closeness = {
                  selector: "node[id_target='" + el.id + "']",
                  style: {
                    "text-transform": "uppercase",
                    color: "#555555",
                    "font-size": "16px",
                    "text-valign": "bottom",
                    "text-halign": "center",
                    "text-outline-color": "#34C38F",
                    "text-outline-width": "2px",
                    color: "#fff",
                    "overlay-padding": "6px",
                    "z-index": "10",
                    "border-color": "#34C38F",
                    "border-opacity": "1",
                    "border-width": "5px",
                  },
                };
                this.config.style.push(text_style_closeness);
              } else {
                let text_style_closeness = {
                  selector: "node[id_target='" + el.id + "']",
                  style: {
                    "text-transform": "uppercase",
                    color: "#555555",
                    "font-size": "16px",
                    "text-valign": "bottom",
                    "text-halign": "center",
                    "text-outline-color": "#34C38F",
                    "text-outline-width": "2px",
                    color: "#fff",
                    "overlay-padding": "6px",
                    "z-index": "10",
                    "border-color": "#34C38F",
                    "border-opacity": "1",
                    "border-width": "5px",
                  },
                };
                this.config.style.push(text_style_closeness);
              }
            }
          });
          response.data.edges.forEach((el, idx) => {
            const data_edges = {
              data: {
                edge_type: "relation",
                source: el[1].id_edge,
                target: el[0].id_edge,
              },
            };
            this.config.elements.edges.push(data_edges);
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
            this.dataRelation = true;
            this.$refs.cyRef.cy.then((cy) => {
              cy.elements().remove();
              cy.add(this.config.elements);
              cy.style(this.config.style);
              cy.layout(this.config.layout).run();
            });
          }, 1500);
        });
    },

    zoomIn() {
      console.log("zoom before ", this.zoomLevel);
      this.zoomLevel += 0.2;
      this.$refs.cyRef.cy.then((cy) => {
        cy.zoom(this.zoomLevel);
      });
      console.log("zoom after ", this.zoomLevel);
      // if (this.zoomLevel <= 5) {
      // }
    },
    zoomOut() {
      if (this.zoomLevel > 0) {
        this.zoomLevel -= 0.2;
        this.$refs.cyRef.cy.then((cy) => {
          cy.zoom(this.zoomLevel);
        });
      }
    },
    resetZoom() {
      this.$refs.cyRef.cy.then((cy) => {
        cy.fit();
        cy.center();
      });
    },
    downloadAsImage() {
      this.$refs.cyRef.cy.then((cy) => {
        saveAs(cy.jpg(), "graph.jpg");
      });
    },

    changeType(mode) {
      this.dataRelation = false;
      this.select_mode = mode;
      const treeLayout = {
        name: "breadthfirst",
        animate: true,
        fit: true,
        nodeOverlap: 0,
        nodeSpacing: 45,
        idealEdgeLength: 200,
        gravity: 1,
        componentSpacing: 40,
        animationDuration: 2000,
      };
      const concentricLayout = {
        name: "concentric",
        animate: true,
        fit: true,
        nodeOverlap: 0,
        nodeSpacing: 45,
        idealEdgeLength: 200,
        gravity: 1,
        componentSpacing: 40,
        animationDuration: 2000,
      };
      const coseLayout = {
        name: "cose-bilkent",
        animate: true,
        fit: true,
        nodeOverlap: 0,
        nodeSpacing: 45,
        idealEdgeLength: 500,
        gravity: 1,
        componentSpacing: 40,
        animationDuration: 2000,
      };

      switch (mode) {
        case "cose":
          this.config.layout = coseLayout;
          break;
        case "tree":
          this.config.layout = treeLayout;
          break;
        case "concentric":
          this.config.layout = concentricLayout;
          break;
        default:
          this.config.layout = coseLayout;
          break;
      }

      this.$refs.cyRef.cy.then((cy) => {
        cy.layout(this.config.layout).stop();
        cy.layout(this.config.layout).run();
      });
    },

    addNode(event) {
      console.log("node clicked", event);
    },
    deleteNode(id) {
      console.log("node clicked", id);
    },
    updateNode(event) {
      console.log("right click node", event);
    },
    preConfig(cytoscape) {
      cytoscape.use(coseBilkent);
      cytoscape.use(avsdf);
      cytoscape.use(cola);
      // cytoscape.use(noOverlap);
    },
    async afterCreated(cy) {
      console.log("Zoom before fit ", cy.zoom());
      cy.userZoomingEnabled(false);
      cy.minZoom(0.1);
      // cy.maxZoom(5.0);
      cy.fit();
      cy.center();
      console.log("Zoom after fit ", cy.zoom());
      this.zoomLevel = 1;
      // console.log("xoom default ", this.zoomLevel);
    },
  },

  filters: {
    upper(value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
    lower(value) {
      if (!value) return "";
      value = value.toString();
      return value.toLowerCase();
    },
  },
  beforeMount() {
    // this.getTargetDetail();
    this.getRelation();
    // this.fitDefault();
  },
};
</script>

<style>
#cytoscape-div {
  height: 100vh !important;
}
/* canvas {
  position: absolute;
  height: 100% !important;
} */
</style>
